import React from 'react';

import './FooterOverlay.css';

import {FiFacebook,FiInstagram,FiTwitter} from 'react-icons/fi'
const FooterOverlay = () => (
  <div className="app__footerOverlay">
    <div className="app__footerOverlay-black" ></div>
    <div className="app__footerOverlay-img app__bg"></div>
  </div>
);

export default FooterOverlay;
